import Message from './Message';
import { IMessage } from './Message.interface';

export default Message;
export { Message, IMessage };
